import React from 'react';
import { Handle, Position } from 'reactflow';
import { EMZI_COLORS, EMZI_RADIUS, EMZI_SPACING } from '../../styles/emziCI';
import { txt } from '../../utils/bilingualText';

const TeamNode = ({ data }) => {
  return (
    <div
      style={{
        padding: EMZI_SPACING.sm,
        borderRadius: EMZI_RADIUS.lg,
        backgroundColor: '#FFFFFF',
        border: `2px solid ${EMZI_COLORS.secondary}`,
        boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
        minWidth: '180px',
        maxWidth: '220px',
      }}
    >
      {/* Team Header */}
      <div style={{ marginBottom: EMZI_SPACING.xs }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '4px' }}>
          <span style={{ fontSize: '18px' }}>👥</span>
          <span
            style={{
              fontSize: '10px',
              fontWeight: '600',
              textTransform: 'uppercase',
              color: EMZI_COLORS.secondary,
              letterSpacing: '0.5px',
            }}
          >
            Team
          </span>
        </div>
        <h3
          style={{
            margin: 0,
            fontSize: '14px',
            fontWeight: '700',
            color: EMZI_COLORS.textPrimary,
            lineHeight: '1.3',
          }}
        >
          {txt(data.name, 'en', 'Untitled Team')}
        </h3>
      </div>

      {/* Team Members Count */}
      {data.memberCount && (
        <div
          style={{
            fontSize: '11px',
            color: EMZI_COLORS.textSecondary,
            display: 'flex',
            alignItems: 'center',
            gap: '4px',
          }}
        >
          <span>👤</span>
          <span>{data.memberCount} members</span>
        </div>
      )}

      {/* Connection Handles */}
      <Handle type="target" position={Position.Top} style={{ background: EMZI_COLORS.secondary }} />
      <Handle type="source" position={Position.Bottom} style={{ background: EMZI_COLORS.secondary }} />
    </div>
  );
};

export default TeamNode;
